'use strict';

var FlightAnalysisToolbarDirective = function FlightAnalysisToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FlightAnalysisToolbarController',
    template: require('../templates/flight-analysis-toolbar.html'),
    scope: {
      screenState: '='
    }
  };
};
FlightAnalysisToolbarDirective.$inject = [];
module.exports = FlightAnalysisToolbarDirective;